import React, { memo } from "react";
import { useTranslate } from "helpers";
import { UserInfoStepProps } from "./types";
import { TextField } from "ui/components/TextField/TextField";
import OibTextField from "ui/components/TextField/OibTextField/OibTextField";
import { useHandleTextFieldChange } from "services/forms/hooks";

const UserInfoStep: React.FC<UserInfoStepProps> = ({
  formValues,
  setFormValues,
  errors,
}) => {
  const { t } = useTranslate();

  const handleTextFieldChange = useHandleTextFieldChange(setFormValues, formValues);

  return (
    <div className="flex items-center justify-center px-4 mt-8 xl:mt-16 min-h-[60vh] xl:min-h-[600px]">
      <div className="w-full max-w-4xl">
        <h1 className="text-2xl font-bold text-slate-900 text-center mb-1">
          Osnovni podaci
        </h1>
        <p className="text-center text-sm text-slate-600 mb-6 max-w-2xl mx-auto ">
          Unesite osnovne podatke korisnika. Nakon unosa možete nastaviti na
          sljedeći korak.
        </p>
        <div className="border border-slate-200">
          <div className="py-6 px-4">
            <div className="flex items-center justify-between mb-3">
                  <h3 className="text-xs uppercase tracking-wide text-slate-400 font-semibold">
                  Osobni podaci
                </h3>
                <p className="text-xs text-slate-500">
                  Unesite ime, prezime i OIB korisnika
                </p>
            </div>
            <div className="grid grid-cols-3 gap-3">
              <div>
                <TextField
                  type="text"
                  name="firstName"
                  label={t("admin.user.edit.firstname")}
                  placeholder={t("admin.user.edit.firstname.placeholder")}
                  onChange={handleTextFieldChange}
                  value={formValues.firstName}
                  error={errors.firstName}
                  required
                />
              </div>
              <div>
                <TextField
                  type="text"
                  name="lastName"
                  label={t("admin.user.edit.lastname")}
                  placeholder={t("admin.user.edit.lastname.placeholder")}
                  onChange={handleTextFieldChange}
                  value={formValues.lastName}
                  error={errors.lastName}
                  required
                />
              </div>
              <div>
                <OibTextField
                  type="text"
                  name="oib"
                  label={t("admin.user.edit.oib")}
                  placeholder={t("admin.user.edit.oib.placeholder")}
                  onChange={handleTextFieldChange}
                  value={formValues.oib}
                  error={errors.oib}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(UserInfoStep);
